export default defineNuxtPlugin({
  name: 'preview',
  setup() {
    const preview = ref(isPreview(document.location.hostname) || false)

    function togglePreview() {
      // nothing here
    }
    try {
      return { provide: { isPreview: preview, togglePreview } }
    } catch (e) {
      useLogger('plugin:preview').error(e)
      throw e
    }
  },
})
